'use strict'
import * as self from './swisstopo.js'

import WMTS from 'ol/source/WMTS'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { get as getProjection } from 'ol/proj'
import { register as registerProj4 } from 'ol/proj/proj4'
import proj4 from '../helpers/projection'

const defaultConfig = {
  extension: 'jpeg',
  serverLayerName: 'ch.swisstopo.pixelkarte-grau'
}

function getValueOrDefault (config, key) {
  if (config === null || typeof config[key] === 'undefined') {
    return defaultConfig[key]
  }
  return config[key]
}

export function getResolutions () {
  return [
    4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250,
    1000, 750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5
  ]
}

export function getUsedProjection () {
  // Register Swiss projection first
  registerProj4(proj4)

  let toReturn = getProjection('EPSG:2056')
  toReturn.setExtent(self.getProjectionExtent())

  return toReturn
}

export function getProjectionExtent () {
  return [2420000, 130000, 2900000, 1350000]
}

export function getDefaultOrigin () {
  let projectionExtent = self.getProjectionExtent()
  return [projectionExtent[0], projectionExtent[3]]
}

export function init () {
  let projection = self.getUsedProjection()

  let resolutions = self.getResolutions()
  let matrixIds = []

  for (var i = 0; i < resolutions.length; i++) {
    matrixIds.push(i)
  }

  return {
    origin: getDefaultOrigin(),
    projection: projection,
    resolutions: resolutions,
    matrixIds: matrixIds
  }
}

export function getWmtsSource (config = null) {
  let parameters = self.init()
  let extension = getValueOrDefault(config, 'extension')

  return new WMTS({
    attributions: '<a target="new" href="https://www.swisstopo.admin.ch/internet/swisstopo/en/home.html">swisstopo</a>',
    url: `https://wmts{1-9}.geo.admin.ch/1.0.0/{Layer}/default/current/2056/{TileMatrix}/{TileCol}/{TileRow}.${extension}`,
    layer: getValueOrDefault(config, 'serverLayerName'),
    projection: parameters.projection,
    requestEncoding: 'REST',
    tileGrid: new WMTSTileGrid({
      origin: parameters.origin,
      resolutions: parameters.resolutions,
      matrixIds: parameters.matrixIds
    })
  })
}

export default self
